import { Component } from '@angular/core';
import {AuthHttp} from 'angular2-jwt/angular2-jwt';
import { AuthService } from './auth.service'
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TopicService } from './topic.service';
import { TagService } from './tag.service';
import { CriterionService } from './criterion.service';
import { SearchTermService } from './search-term.service';
import { DbRecordService } from './db-record.service';
import { NoteService } from './note.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FileService } from './file.service'
import { AdminService } from './admin.service'
import { RuntimeService } from './runtime.service';
import { BatchSearchService } from './batch-search.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor(  //too ensure early initialization
    public utils: UtilsService,
    private auths: AuthService,
    private projects: ProjectService,
    private topics: TopicService,
    private sts: SearchTermService,
    private tags: TagService,
    private criterions: CriterionService,
    private dbrs: DbRecordService,
    private ns: NoteService,
    private ds: DomSanitizer,
    private fs: FileService,
    private ads: AdminService,
    private rs: RuntimeService,
    private bs: BatchSearchService
  ) {
    addEventListener("message", (event) => {
      if (event.origin != "https://gae-test.ecomole.com")
        return
    //  console.log(11111, event)
      if (event.data['app'] != 'searchman')
        return
      this.ads.clearSwitches()
      switch (event.data['fun']) {
        case 'searchFilesUpload':
          return event.data['stats'].forEach((x) => this.fs.newFromSaved(x, true));
        case 'batchSearchUpload':
          return this.bs.init(this.rs.currentProject)
        case 'filesUpload':
          return this.fs.newFromSaved(event.data['stats'][0], true)
      }
    }, false)
  }

  get isAdmin() {
    if (!this.utils)
      return false
    return this.utils.isAdmin
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts